import CentraImage from "./CentraImage";

export default CentraImage;
